
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
  import PickerDate from '@/components/picker-date.vue';
	import RadioButton from '@/components/radio-button.vue';
	import uploadInvoice from './components/uploadInvoice.vue';
  import {
    orderorderInvoiceList
  } from "@/api/order"
  @Component({  
    name: '',
    components: {
      PageFooter,
      PickerDate,
      RadioButton,
      uploadInvoice
    }
  })
  export default class ProductList extends Vue {
    private radioType = 0
    private radioList = [
      {value:0,label:'待开票'},
      {value:1,label:'已开票'},
    ]
    private keywords = ''
    private tablelist:any = []
    private tableloading = false
    private pageNo = 1
    private pageSize = 20
    private total = 0
    private rowmsg:any = {}
    private uploadShow = false
    private uploadType = 1




    private mounted () {
      this.gettablelist()
    }


    private iframDown(url,item){
			const xhr:any = new XMLHttpRequest();
			xhr.open('GET', location.origin+'/image/server?url='+url, true);
			xhr.responseType = 'blob'; // 设置响应类型为blob
			xhr.onload = function(e) {
				console.log(this,1)
				if (this.status === 200) {
					const blob = this.response; // 获取blob对象
					console.log(blob);
					const link = document.createElement('a');
					link.href = URL.createObjectURL(blob);
					link.download = item.OrderNo+'发票';
					link.target = '_blank';
					// return
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
					URL.revokeObjectURL(blob)
				}
			};
			xhr.send();
		}
    private toDetails(row){
      this.$router.push({
        path:'waitInvoiceOrderDetails',
        query:{
          OrderNo:row.OrderNo
        }
      })
    }
    private downFile(row,type){
      if(type==1){
        for(let item of row.OrderDetailList){
          if(item.InvoiceState!=0){
            this.iframDown(item.InvoiceUrlValue,item)
          }
        }
      }else{
        this.iframDown(row.InvoiceUrlValue,row)
      }
    }
    private uploadInvoice(row,type){
      this.rowmsg = JSON.parse(JSON.stringify(row))
      this.uploadShow = true
      this.uploadType = type
    }
    private changRadio(e){
      this.doSearch()
    }
    private clearSearch(){
      this.keywords = ''
      this.doSearch()
    }
    private doSearch(){
      this.pageNo = 1
      this.gettablelist()
    }
    private changePage(e){
      this.pageNo = e
      this.gettablelist()
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let res:any = await orderorderInvoiceList({
          Keywords:this.keywords,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize,
          InvoiceState:this.radioType
        })
        if(res.IsSuccess){
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
  }
